import actions from 'constants/actions';

export function finishInitApp () {
  return {
    type: actions.FINISH_INIT_APP,
  };
}

export function startAppLoading () {
  return {
    type: actions.START_APP_LOADING_GLOBAL,
  };
}

export function stopAppLoading () {
  return {
    type: actions.STOP_APP_LOADING_GLOBAL,
  };
}

// If you want to do something before the app starting, put it in the promise all
// remember to return a Promise in your action (EX: request.get or request.post)
export function initializeApp () {
  return (dispatch) => {
    const currentTime = new Date();
    dispatch(startAppLoading);
    // TODO: dispatch all init action here and push it to below array
    return Promise.all([]).then(() => {
      const delta = new Date() - currentTime;
      const delay =
        delta > CONFIG.MIN_TIME_INIT_APP ? 0 : CONFIG.MIN_TIME_INIT_APP - delta;
      setTimeout(() => {
        dispatch(finishInitApp());
        dispatch(stopAppLoading);
      }, delay);
    });
  };
}
